module.exports = __webpack_public_path__ + "e3ee55e64045b378635b66e940aac11a.jpg";